import { NgModule,CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA  } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import 'hammerjs';
import { SharedModule } from './core/modules/shared.module';
import { AppComponent } from './app.component';
import { FuseMainModule } from './main/main.module';
import { FuseSplashScreenService } from './core/services/splash-screen.service';
import { FuseConfigService } from './core/services/config.service';
import { AjaxService } from './core/services/ajax.service'
import { ContentModule } from './main/content/content.module';
import { FuseNavigationService } from './core/components/navigation/navigation.service';


const appRoutes: Routes = [
   
    {
        path      : 'user',
        redirectTo: 'user'
    },
    {
        path      : 'login',
        redirectTo: 'login'
    },
    {
        path      : 'resetpassword',
        redirectTo: 'resetpassword'
    }
    ,
    {
        path      : 'resetpasswordconfirm',
        redirectTo: 'resetpasswordconfirm'
    },
    {
        path       : 'dashboard',
        redirectTo : 'dashboard'
    },
   
];

@NgModule({
    declarations: [
        AppComponent
    ],
    imports     : [
        BrowserModule,
        HttpModule,
        HttpClientModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes),
        SharedModule,
        FuseMainModule,
        ContentModule,
        FormsModule 
    ],
    providers   : [
        FuseSplashScreenService,
        FuseConfigService,
        AjaxService,
        FuseNavigationService,
    ],
    bootstrap   : [
        AppComponent
    ],
    entryComponents: [
    ],
    schemas: [
        NO_ERRORS_SCHEMA,
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class AppModule
{
}


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/app.module.ts